import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MarkdownItPipe } from '../../pipes/markdown-it.pipe';

@Component({
  selector: 'app-question-button',
  templateUrl: './question-button.component.html',
  styleUrls: ['./question-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NzButtonModule, NzToolTipModule, NzPopoverModule, NzIconModule, MarkdownItPipe],
})
export class QuestionButtonComponent {
  @Input() text: string = '';
  @Input() isMarkdown: boolean = false;

  popover: string = '';

  ngOnInit() {
    this.popover = this.text;
  }
}
